import httpClient from './api/httpClient';

const END_POINT = 'membro-familiar';
//export const getAll = () => httpClient.get(END_POINT + '/all');
export const getMembrosPorCandidato = () => httpClient.get(END_POINT + '/getMembrosPorCandidato');

export const getMembrosPorCandidatoId = (idPrematricula) => httpClient.get(END_POINT + '/getMembrosPorCandidatoId/'+idPrematricula);

export const getMembrosRendaBrutaPerCapta = () => httpClient.get(END_POINT + '/getMembrosRendaBrutaPerCapta');

export const getMembrosRendaBrutaPerCaptaPorId = (idPrematricula) => httpClient.get(END_POINT + '/getMembrosRendaBrutaPerCaptaPorId/' + idPrematricula);

export const getMembrosRendaPerCapta = () => httpClient.get(END_POINT + '/getMembrosRendaPerCapta');

export const getMembrosRendaPerCaptaPorId = (idPrematricula) => httpClient.get(END_POINT + '/getMembrosRendaPerCaptaPorId/' + idPrematricula);

export const getSalarioReferenciaPerCapta = () => httpClient.get(END_POINT + '/getSalarioReferenciaPerCapta');

export const getSalarioReferenciaPerCaptaPorId = (idPrematricula) => httpClient.get(END_POINT + '/getSalarioReferenciaPerCaptaPorId/'+ idPrematricula);

export const create = (membroFamiliar) => {
    let membroFamiliarForm = {
        id: membroFamiliar.id,        
        nome: membroFamiliar.nome,
        idade: membroFamiliar.idade,
        parentesco: membroFamiliar.parentesco,
        estado_civil: membroFamiliar.estado_civil,
        profissao: membroFamiliar.profissao,
        renda_bruta: membroFamiliar.renda_bruta,
        periodo: membroFamiliar.periodo,
    };
    return httpClient.post(END_POINT, membroFamiliarForm);
}

export const update = (membroFamiliar) => {
    let membroFamiliarForm = {
        'id': membroFamiliar.id,
        'nome': membroFamiliar.nome,
        'idade': membroFamiliar.idade,
        'parentesco': membroFamiliar.parentesco,
        'estado_civil': membroFamiliar.estado_civil,
        'profissao': membroFamiliar.profissao,
        'renda_bruta': membroFamiliar.renda_bruta,
        'periodo': membroFamiliar.periodo,
    }
    return httpClient.patch(END_POINT + "/update/" + membroFamiliar.id, membroFamiliarForm);
}

export const deletar = (membroFamiliar) =>{     
    return httpClient.patch(END_POINT + "/deletar/" + membroFamiliar);
}





